import { takeLatest, put, call } from "redux-saga/effects";
import * as API from "us.collection.admin/services";
import * as Actions from "us.collection.admin/actions";
import { NonProductionDay } from "us.collection.admin/constants/Actions";
import { $Message, $MessageBox } from "us.common/components";
import { getFormattedRedDays } from "us.collection.admin/functions/NonProductionDays";
import { i18n } from "us.helper";

const { nonProductionDays_New } = Actions;

const NonProductionDaySagas = {
  calendar: {
    update: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        const data = yield call(API.nonProductionDays.calendar.update, params);
        $MessageBox(
          "success",
          `US.COMMON:MESSAGES.SUCCESSFULLY_UPDATED`,
          "",
          ""
        );
        yield put(nonProductionDays_New.calendar.success(data));
      } catch (error) {
        $MessageBox(
          "error",
          "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.CALENDAR_UPDATE_FAILED",
          "",
          ""
        );
        yield put(nonProductionDays_New.calendar.fail(error as any));
      }
    },
    init: function* (action: any): any {
      try {
        const params = action?.payload?.data ?? {};
        const data = yield call(API.nonProductionDays.calendar.init, params);
        if (nonProductionDays_New.calendar.initSuccess) {
          yield put(nonProductionDays_New.calendar.initSuccess(data));
        }
      } catch (error) {
        if (nonProductionDays_New.calendar.initFail) {
          yield put(nonProductionDays_New.calendar.initFail(error as any));
        }
      }
    },
  },

  ScheduleTimeSlots: {
    get: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        const data = yield call(
          API.nonProductionDays.ScheduleTimeSlots.get,
          params
        );
        yield put(nonProductionDays_New.ScheduleTimeSlots.success(data));
      } catch (error) {
        yield put(nonProductionDays_New.ScheduleTimeSlots.fail(error as any));
      }
    },
  },
  redDays: {
    get: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        const data = yield call(API.nonProductionDays.redDays.get, params);
        yield put(
          nonProductionDays_New.redDays.success(getFormattedRedDays(data))
        );
      } catch (error) {
        yield put(nonProductionDays_New.redDays.fail(error as any));
      }
    },
    update: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        $Message.loading(i18n.t("COMMON.UPDATING") as string, 0);
        const { data, status } = yield call(
          API.nonProductionDays.redDays.update,
          params
        );
        if (status == 201) {
          if (nonProductionDays_New.redDays.updateSuccess) {
            yield put(nonProductionDays_New.redDays.updateSuccess(params));
          }
          const data = yield call(API.nonProductionDays.redDays.get, params);
          yield put(
            nonProductionDays_New.redDays.success(getFormattedRedDays(data))
          );
          $Message.destroy();
          $MessageBox(
            "success",
            "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.CALENDAR_UPDATED_SUCCESSFULLY",
            "",
            ""
          );
        } else {
          if (nonProductionDays_New.redDays.updateFail) {
            yield put(nonProductionDays_New.redDays.updateFail(params));
          }
          $Message.destroy();
          if (status === 409) {
            $MessageBox(
              "error",
              "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.DUPLICATE_ENTRY_ERROR_MESSAGE",
              "",
              ""
            );
          } else {
            $MessageBox(
              "error",
              "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.CALENDAR_UPDATE_FAILED",
              "",
              ""
            );
          }
        }
      } catch (error) {
        if (nonProductionDays_New.redDays.updateFail) {
          yield put(nonProductionDays_New.redDays.updateFail(error as any));
        }
        $Message.destroy();
        $MessageBox(
          "error",
          "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.CALENDAR_UPDATE_FAILED",
          "",
          ""
        );
      }
    },
    delete: function* (action: any): any {
      const params = action?.payload?.data ?? {};
      try {
        $Message.loading(i18n.t("COMMON.DELETING") as string, 0);
        const { data, status } = yield call(
          API.nonProductionDays.redDays.delete,
          params
        );
        if (status == 200) {
          const data = yield call(API.nonProductionDays.redDays.get, params);
          yield put(
            nonProductionDays_New.redDays.success(getFormattedRedDays(data))
          );
          $Message.destroy();
          $MessageBox(
            "success",
            "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.CALENDAR_UPDATED_SUCCESSFULLY",
            "",
            ""
          );
        } else {
          $Message.destroy();
          $MessageBox(
            "error",
            "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.CALENDAR_UPDATE_FAILED",
            "",
            ""
          );
        }
      } catch (error) {
        $Message.destroy();
        $MessageBox(
          "error",
          "US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.CALENDAR_UPDATE_FAILED",
          "",
          ""
        );
      }
    },
  },
};

export default [
  takeLatest(
    NonProductionDay.GET_SCHEDULES_TIME_SLOTS,
    NonProductionDaySagas.ScheduleTimeSlots.get
  ),
  takeLatest(
    NonProductionDay.GET_NON_PRODUCTION_DAYS,
    NonProductionDaySagas.redDays.get
  ),
  takeLatest(
    NonProductionDay.SAVE_NON_PRODUCTION_DAYS,
    NonProductionDaySagas.redDays.update
  ),
  takeLatest(
    NonProductionDay.SAVE_CALENDAR,
    NonProductionDaySagas.calendar.update
  ),
  takeLatest(
    NonProductionDay.INIT_NON_PRODUCTION,
    NonProductionDaySagas.calendar.init
  ),
  takeLatest(
    NonProductionDay.DELETE_NON_PRODUCTION_DAYS,
    NonProductionDaySagas.redDays.delete
  ),
];
